const LOGO_SCALE = 0.35
const LOGO_MARKERS = ['/icons/my_logo.png', '/icons/my-logo.png', '/icons/my_logo', 'my_logo.png']

let logoSizePromise: Promise<{ width: number; height: number } | null> | null = null

const loadLogoSize = async () => {
  if (logoSizePromise) return logoSizePromise
  logoSizePromise = new Promise((resolve) => {
    const image = new Image()
    image.onload = () => {
      resolve({
        width: image.naturalWidth || 0,
        height: image.naturalHeight || 0,
      })
    }
    image.onerror = () => resolve(null)
    image.src = '/icons/My_logo.png'
  })
  return logoSizePromise
}

export const applyLogoFallbackStyle = (img: HTMLImageElement) => {
  img.style.objectFit = 'contain'
  img.style.objectPosition = 'center'
  img.style.transform = `scale(${LOGO_SCALE})`
  img.style.transformOrigin = 'center center'
  img.style.opacity = '0.35'
  img.style.filter = 'grayscale(0.15)'
}

const hasLogoMarker = (url: string) => {
  const normalized = String(url || '').toLowerCase()
  return LOGO_MARKERS.some((marker) => normalized.includes(marker))
}

export const markLogoLikeImageIfNeeded = async (img: HTMLImageElement) => {
  if (!img) return
  if (hasLogoMarker(img.currentSrc || img.src)) {
    applyLogoFallbackStyle(img)
    return
  }
  const logoSize = await loadLogoSize()
  if (!logoSize) return
  const width = img.naturalWidth || 0
  const height = img.naturalHeight || 0
  if (width > 0 && height > 0 && width === logoSize.width && height === logoSize.height) {
    applyLogoFallbackStyle(img)
  }
}
